export default __webpack_public_path__ + "static/logo-white-80632f4bb762fc40d67e534063ee93d4.png";